import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"
import quoteMark from "../../images/icons/quoteMark.svg"

export const ContentWrapper = styled.div`

  :last-child {
    margin-bottom: 0 !important;
  }

  > h1,
  > h2,
  > h3,
  > h4,
  > h5 {
    @media ${device.desktop} {
      float: left;
      margin-top: 0;
    }
  }

  > h1 {
    font-size: 30px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 1;
    margin-bottom: 24px;

    @media ${device.tablet} {
      float: left;
      width: 25%;
      height: 100%;
    }

    @media ${device.desktop} {
      font-size: 64px;
      line-height: 0.75;
    }
  }

  > h2 {
    font-size: 30px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 34px;
    margin-bottom: 24px;

    @media ${device.tablet} {
      float: left;
      width: 25%;
      height: 100%;
    }

    @media ${device.desktop} {
      font-size: 42px;
      line-height: 48px;
    }
  }

  > h3 {
    font-weight: 700;
    font-size: 28px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 32px;
    margin-bottom: 22px;

    @media ${device.tablet} {
      float: left;
      width: 30%;
      height: 100%;
    }

    @media ${device.desktop} {
      font-size: 36px;
      line-height: 42px;
    }
  }

  > h4 {
    font-size: 24px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 16px;

    @media ${device.tablet} {
      float: left;
      width: 25%;
      height: 100%;
    }
    @media ${device.desktop} {
      font-size: 32px;
      line-height: 36px;
    }
  }

  > h5 {
    font-weight: 700;
    font-size: 20px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 20px;

    @media ${device.tablet} {
      float: left;
      width: 25%;
      height: 100%;
    }

    @media ${device.desktop} {
      font-size: 28px;
      line-height: 32px;
    }
  }

  > h6 {
    font-weight: 600;
    font-size: 18px;
    color: #0000ff;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 12px;

    @media ${device.tablet} {
      margin-left: 35%;
    }
    @media ${device.desktop} {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 24px;
    }
  }

  > p {
    font-weight: 300;
    font-size: 16px;
    color: #5a5a5a;
    letter-spacing: 0.44px;
    line-height: 24px;
    margin-bottom: 23px;

  span {
      font-weight: 700;
      color: #0000ff;
    }

    ${props =>
      !props.clean &&
      `
      &:first-of-type {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        letter-spacing: 0;
        line-height: 24px;
        @media ${device.desktop} {
          font-size: 24px;
          color: #000000;
          letter-spacing: 0;
          line-height: 32px;
          padding-right: 60px;
        }
      }

    `}
  

    




    @media ${device.tablet} {
      margin-left: 35%;
      margin-top: 0;
    }
    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: 0.56px;
      line-height: 30px;
      margin-left: 35%;
      margin-bottom: 32px;
    }

    a {
      display: inline-block;
      position: relative;
      color: ${props => props.theme.primaryColor};
      font-weight: 600;
      ::after {
        content: "";
        position: absolute;
        bottom: 3px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${props => props.theme.green};
        opacity: 0;
        transition: 90ms;
      }
      :hover {
        ::after {
          opacity: 1;
        }
      }
    }
  }



  figure {
    width: 100%;
    margin: 0 auto;
    @media ${device.tablet} {
      margin-left: 35%;
      width: 65%;

      &.alignwide, &.alignfull {
        margin-left: 0;
        width: 100%;
      }
    }
  }

  .wp-block-image {
    margin-top: 30px;
    margin-bottom: 30px;
    @media ${device.desktop} {
      margin-bottom: 60px;
      margin-top: 60px;
    }

    img {
      width: 100%;
      display: block;
    }
  }

  blockquote {
    margin-top: 39px;
    margin-bottom: 30px;
    position: relative;
    padding-left: 46px;

    @media ${device.tablet} {
      margin-left: 28.8%;
      width: 70%;
      padding-left: 6%;
    }
    @media ${device.desktop} {
      margin-left: 29%;
      margin-bottom: 59px;
    }

    :before {
      content: "";
      position: absolute;
      height: 25px;
      width: 28px;
      background-image: url('${quoteMark}');
      background-size: 100%;
      background-repeat: no-repeat;
      display: block;
      top: 0;
      left: 0;

      @media ${device.desktop} {
        width: 49px;
        height: 42px;
        left: -5px;
        top: -9px;

      }
    }

    svg {
      width: 28px;
      height: 24px;
    }

    p {
      font-weight: 500;
      font-size: 20px;
      color: #0000ff;
      letter-spacing: 0;
      line-height: 28px;
      margin-left: 0;
      padding-right: 5px;
      margin-bottom: 14px;
      display: block;

      @media ${device.desktop} {
        font-size: 32px;
        line-height: 40px;
        margin-top: 51px;
        margin-bottom: 34px;
      }
    }

    cite {
      font-size: 12px;
      color: #5a5a5a;
      letter-spacing: 0.33px;
      line-height: 27px;
      margin-left: -45px;
      padding-left: 44px;
      position: relative;
      font-style: normal;

      @media ${device.tablet} {
        font-size: 14px;
        letter-spacing: 0.39px;
        padding-left: 98px;
      }
      @media ${device.desktop} {
        padding-left: 55px;
        margin-left: 0;
      }

      ::before {
        content: "";
        position: absolute;
        height: 3px;
        width: 28px;
        top: 7px;
        left: 0;
        background-color: ${props => props.theme.green};
        @media ${device.tablet} {
          left: 44px;
        }
        @media ${device.desktop} {
          left: 0;
          width: 33px;
        }
      }
    }

    &.is-style-left-quote, &.is-style-left-quote-margin-top {

      @media ${device.desktop} {
        margin: 0;
        margin-top:-6px;
        width: calc(35% - 40px);
        float: left;
        padding-left: 54px;



        &:before {
          width: 36px;
          height: 31px;
          top: 0;
          left: 0;
        }

        p {
          font-size: 24px;
          margin-top: 7px;
          line-height: 1.333;
          margin-bottom: 24px;
        }
      }

      cite {
        @media ${device.desktop} {
        padding-left:0;
        margin-top:48px;
        display:block;
        line-height:143%;
        :before {
          top:-26px;
        }
        }
      }
    }
    &.is-style-left-quote-margin-top {
      margin-top: 32px;

    }
  }

  > ul {
    margin-left: 25px;
    margin-bottom: 25px;

    @media ${device.desktop} {
      margin-bottom: 32px;
    }

    li {
      font-weight: 300;
      font-size: 16px;
      color: #5a5a5a;
      letter-spacing: 0.44px;
      line-height: 24px;

      list-style-type: none;
      position: relative;
      margin-bottom: 18px;

      @media ${device.tablet} {

        margin-left: 36%;
      }
      @media ${device.desktop} {
        font-size: 20px;
        margin-bottom: 27px;
        margin-left: 36.5%;

      }

      ::before {
        content: "";
        height: 8px;
        width: 8px;
        background-color: ${props => props.theme.green};
        display: block;
        border-radius: 50%;
        position: absolute;
        top: 9px;
        left: -25px;

        @media ${device.desktop} {
          top: 8px;
          font-size: 20px;
          left: -30px;
        }
      }
    }
  }

  > ol {
    list-style: none;
    counter-reset: counter;
    margin-left: 24px;
    margin-bottom: 25px;

    @media ${device.desktop} {
      margin-bottom: 32px;
    }
  }
  ol li {
    font-weight: 300;
    font-size: 16px;
    color: #5a5a5a;
    letter-spacing: 0.44px;
    line-height: 24px;
    counter-increment: counter;
    position: relative;
    padding-left: 19px;
    display: block;
    margin-bottom: 16px;

    @media ${device.tablet} {
      margin-left: 36%;
    }
    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: 0.56px;
      line-height: 30px;
      padding-left: 29px;
      margin-left: 35.8%;
      margin-bottom: 21px;
    }
  }
  ol li::before {
    content: counter(counter);
    position: absolute;
    left: -25px;
    top: 0;
    height: 27px;
    width: 27px;
    border: 3px solid ${props => props.theme.green};
    text-align: center;
    font-weight: bold;
    border-radius: 25px;
    font-weight: 700;
    font-size: 16px;
    color: ${props => props.theme.green};
    letter-spacing: 0.56px;
    text-align: center;
    line-height: 22px;

    @media ${device.desktop} {
      font-size: 20px;
      text-align: center;
      line-height: 30px;

      height: 36px;
      width: 36px;
    }
  }

  figure.is-type-video {

    margin-top: 45px;
    margin-bottom: 26px;
    @media ${device.desktop} {
      margin-bottom: 60px;
      margin-top: 60px;
    }

    .wp-block-embed__wrapper {
      position: relative;
      padding-bottom: 56.25%;

      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }

    }
  }
`
